
<template>
  <div class="inOutReport">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container" >
          收支报表 
          <el-tooltip class="item" effect="dark"  placement="top-start">
            <div slot="content" style="line-height:20px;">
              1、统计选定基地和塘口下，在选定的年份中所有周期的收支概况；<br/>
              2、当周期在选定年度没有清塘时，则支出和收益计算截止到当前；<br/>
              3、当周期在选定年度已经清塘，则支出和收益计算截止到清塘日；
            </div>
            <img src="../../../public/img/icon_prompt_2.png" alt="" style="padding-top:4px;">
          </el-tooltip>
        
        </div>
        <div class="select-container">
           <div class="select-container-box tab">
              <el-select v-model="memoryValue" size="small"  placeholder="请选择" @change="changeBatDateList">
                <el-option
                  v-for="item in batDateList"
                  :key="item.value" 
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          <div class="select-container-box" v-if="memoryValue=='date'">
            <!-- <span>时间&nbsp;&nbsp;</span> -->
            <el-date-picker
              size="small"
              v-model="start"
              type="date"
              :clearable="false"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(0)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
            <span>至</span>
            <el-date-picker
              size="small"
              v-model="end"
              type="date"
              :clearable="false"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(1)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box"  v-if="memoryValue=='Batch'">
            <!-- <span>周期&nbsp;&nbsp;</span> -->
            <el-select v-model="batch" size="small"  placeholder="请选择" @change="batchChange">
              <el-option
                v-for="item in batchList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="order.baseId" @change="baseChange">
              <el-option
                v-for="(item, index) in baseList" 
                :key="index" 
                :label="item.value" 
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="this.pondList.length>=0">
            <span>塘口&nbsp;&nbsp;</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="order.pondId"  @change="pondChange">
              <el-option
                v-for="(item, index) in pondList" 
                :key="index" 
                :label="item.value" 
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small"  type="info" plain @click="search()" class="query">查询</el-button>
            <!-- <el-button size="small"  type="info" plain  class="outPut">导出</el-button> -->
          </div>
          <!-- <div class="select-container-box" >
            <span>年度</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="order.year"  @change="yearChange">
              <el-option
                v-for="(item, index) in yearList"
                 :key="index" 
                :label="item.name" 
                :value="item.name">
              </el-option>
            </el-select>
          </div> -->
        </div>
      </div>
      <!-- 支出 -->
      <div class="table-container onePart" >
        <div class="left">
          <div ref="outBar"  class="outBar" style="height:532px;"></div>
          <div class="nodata" v-if="outShow">
            <img src="../../../public/img/nodata.png" alt="">
            <span>暂无数据</span>
          </div>
        </div>
        <div class="right">
          <el-table
            :data="groupByNameList"
            type="index"
            :cell-class-name="cellClassName"
            row-key="id"
            :tree-props="{children: 'item', hasChildren: 'hasChildren'}"
            style="width: 100%;max-height:441px;overflow:auto;background:#fff;margin-top:10px;">
            <el-table-column label="费用类目" align="center" prop="name" />
            <el-table-column label="费用名称" align="center" prop="costName"/>
            <el-table-column label="支出总额" :formatter="numToFixed" align="center" prop="count"/>
          </el-table>
          <!-- <el-table
            :data="groupByNameList"
            show-summary
            :row-class-name="tableRowClassName"
            :summary-method="getSummaries"
            @row-click="openOutDetails()"
            type="index"
            style="width: 100%;max-height:441px;overflow:auto;background:#fff;margin-top:10px;">
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="expense" v-for="(item,m) in groupByNameList[scope.$index].item" :key="m">
                 <span></span> 
                 <span class="span1">{{item.costName}}</span>
                  <span class="span2">{{item.amount.toFixed(2)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="费用类目"
              align="center"
              prop="name">
            </el-table-column>
            <el-table-column
              label="费用名称"
              align="center"
              prop="">
            </el-table-column>
            <el-table-column
              label="支出总额"
              :formatter="numToFixed"
              align="center"
              prop="count">
            </el-table-column>
          </el-table> -->
        </div>
      </div>
      <!-- 收入 -->
      <div class="table-container twoPart" >
        <div class="left">
          <div ref="intBar"  class="intBar" style="height:532px;"></div>
          <div class="nodata" v-if="inShow">
            <img src="../../../public/img/nodata.png" alt="">
            <span>暂无数据</span>
          </div>
        </div>
        <div class="right">
          <el-table
            :data="this.InOutReportDataList"
            show-summary
            :summary-method="getInSummaries"
            style="width: 100%;max-height:441px;overflow:auto;background:#fff;">
            <el-table-column
              label="鱼种"
              align="center"
              prop="fishName">
            </el-table-column>
            <el-table-column
              label="收入总额"
              align="center"
              :formatter="numToFixed"
              prop="amount">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 收入支出结余 -->
      <div class="table-container therePart" >
        <div ref="intOutCompareLine"  class="intOutCompareLine" style="height:495px;"></div>
        <div class="therePart-table">
          <el-table
            :data="this.groupByYearList"
            show-summary
            :summary-method="getInOutSummaries"
            style="width: 100%">
             <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="compare" v-for="(item,m) in groupByYearList[scope.$index].item" :key="m">
                <span></span>
                <span>{{item.month}}月</span>
                <span>{{item.income.toFixed(2)}}</span>
                <span>{{item.expenditure.toFixed(2)}}</span>
                <span>{{item.balance.toFixed(2)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="年份"
              align="center"
              prop="name">
            </el-table-column>
            <el-table-column
              label="月份"
              align="center"
              prop="months">
            </el-table-column>
            <el-table-column
              label="收入总额"
               align="center"
              prop="income">
              <template slot-scope="scope">
                <span>{{scope.row.income|decimal}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="支出总额"
               align="center"
              prop="expenditure">
              <template slot-scope="scope">
                <span>{{scope.row.expenditure|decimal}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="结余"
               align="center"
               :formatter="filterNumber"
              prop="balance">
              <template slot-scope="scope">
                <span>{{scope.row.balance|decimal}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import echarts from "echarts";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";

export default {
  mixins: [mixins],
  name: "InOutReport",
  data() {
    return {
      memoryValue: "date",
      batDateList: [
        {
          value: "Batch",
          label: "周期"
        },
        {
          value: "date",
          label: "时间"
        }
      ],
      batch: "",
      batchList: [],
      outShow: false,
      inShow: false,
      inoutshow: false,
      content:
        "1、统计选定基地和塘口下，在选定的年份中所有周期的收支概况；" +
        <br /> +
        "2、当周期在选定年度没有清塘时，则支出和收益计算截止到当前；" +
        "3、当周期在选定年度已经清塘，则支出和收益计算截止到清塘日；",
      order: {
        year: "2020", //年度
        baseId: "", //基地
        pondId: "" //塘口
      },
      start: "",
      end: "",
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      baseList: [],
      pondList: [],
      yearList: [
        {
          id: 1,
          name: 2017
        },
        {
          id: 2,
          name: 2018
        },
        {
          id: 3,
          name: 2019
        },
        {
          id: 4,
          name: 2020
        },
        {
          id: 5,
          name: 2021
        },
        {
          id: 6,
          name: 2022
        },
        {
          id: 7,
          name: 2023
        },
        {
          id: 8,
          name: 2024
        },
        {
          id: 9,
          name: 2025
        }
      ],

      //支出堆积图相关
      restructuringData: [],
      groupByNameList: [],
      xDataName: [],
      expenseSeriesData: [],
      expenseLegendData: [],
      outDataList: [],
      outStart: "",
      outEnd: "",
      //收入堆积图相关
      InOutReportDataList: [],
      xData: [],
      legendData: [],
      seriesData: [],
      inOutStart: "",
      inOutEnd: "",
      //对比分析图相关
      compareXData: [],
      groupByYearList: [],
      seriesData0: [], //收入
      seriesData1: [], //支出
      seriesData2: [], //结余
      compareDataList: [],
      compareStart: "",
      compareEnd: ""
    };
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
  async mounted() {
    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    this.order.baseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    await this.baseChange(this.order.baseId);

    this.judgeChoose();
    this.getBatch();
    this.getAllData();
  },
  methods: {
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    ...mapActions(modules.inOutReport, [
      "outComeExpenditure",
      "inOutReportData",
      "compareLineData"
    ]), //报表堆积图
    ...mapActions(modules.cultureCycle, {
      getBatchList: "getBatchList" //周期下拉
    }),

    // 获取周期下拉
    async getBatch() {
      this.batchList = await this.getBatchList();
      this.batchList.unshift("全部");
      // this.batchList = this.batchList;
      this.batch = "全部";
    },
    // 判断localstorage 是周期还是时间
    judgeChoose() {
      let memoryValue = localStorage.getItem("memoryValue");
      if (memoryValue) {
        this.memoryValue = memoryValue;
      } else {
        this.memoryValue = this.memoryValue;
      }
      if (this.memoryValue == "Batch") {
        // this.start = "";
        // this.end = "";
        this.batch = "全部";
      } else if (this.memoryValue == "date") {
        this.batch = "";
      }
    },
    //切换时间和周期
    changeBatDateList(e) {
      localStorage.setItem("memoryValue", e);
      console.log(e);
      if (e == "Batch") {
        // this.start = "";
        // this.end = "";
        this.batch = "全部";
      } else if (e == "date") {
        this.batch = "";
      }
    },
    //周期切换
    batchChange(e) {
      if (e) {
        this.batch = e;
        this.getAllData();
      }
    },
    filterNumber(row) {
      return row.balance.toFixed(2);
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    numToFixed(row, column) {
      if (row.count) {
        return row.count.toFixed(2);
      } else if (row.amount) {
        return row.amount.toFixed(2);
      }
    },
    //支出合计/支出总额
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "支出总计（元）";
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "";
        }
      });
      if (sums.length == 4 && sums[3] !== "") {
        sums[3] = parseFloat(sums[3]).toFixed(2);
      }
      console.log(sums, 233);
      sums[1] = ''
      return sums;
    },

    //收入合计
    getInSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "收入总计（元）";
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);

            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "";
        }
      });

      if (sums.length == 2 && sums[1] !== "") {
        sums[1] = parseFloat(sums[1]).toFixed(2);
      }
      return sums;
    },
    //收入支出结余
    getInOutSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "";
        }
      });
      if (sums.length == 6 && sums[5] !== "") {
        sums[3] = parseFloat(sums[3]).toFixed(2);
        sums[4] = parseFloat(sums[4]).toFixed(2);
        sums[5] = parseFloat(sums[5]).toFixed(2);
      }
      return sums;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    openOutDetails(row, event, column) {},
    //获取三个报表数据
    async getAllData() {
      // 支出堆积图相关
      let outCome = await this.outComeExpenditure({
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        pondId: this.order.pondId,
        // year: this.order.year
        batch: this.batch == "全部" ? "" : this.batch,
        startDate: this.memoryValue == "date" ? this.start : "",
        endDate: this.memoryValue == "date" ? this.end : ""
      });
      console.log(4444, outCome);

      this.outDataList = outCome.data.expenditures;
      if (this.outDataList.length != 0) {
        this.outShow = false;
        this.restructuringData = this.arrayReorganization(this.outDataList);
        this.groupByNameList = this.groupByName(this.outDataList);
        this.xDataName = await this.getThebase(this.restructuringData);
        this.expenseLegendData = this.getLegend(this.outDataList);
        this.outStart = this.$timeformatDays(outCome.data.batchStart);
        this.outEnd = this.$timeformatDays(outCome.data.batchEnd);
        this.outBar();
      } else {
        this.xDataName = [];
        this.expenseLegendData = [];
        this.restructuringData = [];
        this.outShow = true;
        this.groupByNameList = [];
        this.outStart = this.$timeformatDays(outCome.data.batchStart);
        this.outEnd = this.$timeformatDays(outCome.data.batchEnd);
        this.outBar();
      }

      //收入堆积图相关
      let inOutData = await this.inOutReportData({
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        pondId: this.order.pondId,
        // year: this.order.year
        batch: this.batch == "全部" ? "" : this.batch,
        startDate: this.memoryValue == "date" ? this.start : "",
        endDate: this.memoryValue == "date" ? this.end : ""
      });
      this.InOutReportDataList = inOutData.data.incomes;
      this.InOutReportDataList.forEach(f => {
        return f.amount.toFixed(2);
      });

      if (this.outDataList.length != 0) {
        this.inShow = false;

        this.inOutStart = this.$timeformatDays(inOutData.data.batchStart);
        this.inOutEnd = this.$timeformatDays(inOutData.data.batchEnd);
        this.intBar(this.InOutReportDataList);
      } else {
        this.inOutStart = this.$timeformatDays(inOutData.data.batchStart);
        this.inOutEnd = this.$timeformatDays(inOutData.data.batchEnd);
        this.intBar(this.InOutReportDataList);
        this.inShow = true;
      }

      //对比分析图相关
      let compareData = await this.compareLineData({
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        pondId: this.order.pondId,
        batch: this.batch == "全部" ? "" : this.batch,
        startDate: this.memoryValue == "date" ? this.start : "",
        endDate: this.memoryValue == "date" ? this.end : ""
        // year: this.order.year
      });
      this.compareDataList = compareData.data.compareds;
      this.groupByYearList = this.groupByYear(this.compareDataList);
      this.compareStart = this.$timeformatDays(inOutData.data.batchStart);
      this.compareEnd = this.$timeformatDays(inOutData.data.batchEnd);
      this.intOutCompareLine(this.compareDataList);
    },
    //改变基地数据
    async baseChange(e) {
      if (e) {
        this.order.baseId = e;
      } else {
        this.order.baseId = this.baseList[0].key;
      }

      storage.set("base", e);
      this.pondList = [];
      // if (!e) return;
      if (e) {
        let result = await this.getFishPond(e);
        this.pondList = [
          {
            key: "",
            value: "全部"
          }
        ].concat(result);
        this.order.pondId = this.pondList[0].key;
      } else {
        this.pondList = [
          {
            key: "",
            value: "全部"
          }
        ];
        this.order.pondId = this.pondList[0].key;
      }
      this.getAllData();
    },
    search() {
      this.getAllData();
    },
    //改变塘口获取数据
    async pondChange(e) {
      this.order.pondId = e;
      this.getAllData();
    },
    //改变年度获取数据
    async yearChange(e) {
      this.order.year = e;
      this.getAllData();
    },

    //收入堆积图
    intBar(e) {
      let myChart = this.$echarts.init(this.$refs.intBar);
      myChart.showLoading({
        text: "数据获取中",
        textColor: "#fff",
        effect: "whirling",
        maskColor: "rgba(255, 255, 255, 0)"
      });
      setTimeout(function() {
        myChart.hideLoading();
      }, 500);
      myChart.clear();
      //x轴
      this.xData = (function() {
        let res = [];
        let len = e.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push(e[i].fishName);
        }
        return res;
      })();
      //数据
      this.seriesData = (function() {
        let res = [];
        let len = e.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push(e[i].amount.toFixed(2));
        }
        return res;
      })();

      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: "{b}:{c}",
          axisPointer: {
            lineStyle: {
              color: "rgba(255,255,255,0.0001)"
            }
          }
        },
        title: {
          text: "收入堆积图",
          subtext: this.memoryValue === 'date' ?  (this.inOutStart + "-" + this.inOutEnd) : '',
          x: "center",
          itemGap: 15,
          top: 20,
          textStyle: {
            color: "#333333",
            fontSize: 20,
            fontWeight: "bold"
          },
          subtextStyle: {
            color: "#999",
            fontSize: 16
          }
        },
        grid: {
          left: "1%",
          right: "4%",
          bottom: "5%",
          top: "20%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: false
            },
            axisLabel: {
              color: "#333",
              fontSize: 15
            },
            axisTick: {
              //y轴刻度线
              show: false
            },
            data: this.xData
          }
        ],
        yAxis: [
          {
            axisLabel: {
              color: "#999",
              fontSize: 14
            },
            axisLine: {
              show: false
            },
            name: this.unitY,
            axisTick: {
              //y轴刻度线
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "rgba(234,234,234,1)"
              }
            },
            type: "value"
          }
        ],
        series: [
          {
            name: this.xData,
            barWidth: 40, //柱图宽度
            type: "bar",
            itemStyle: {
              normal: {
                color: function(params) {
                  //首先定义一个数组
                  var colorList = [
                    "#4A89F1",
                    "#29C8A2",
                    "#F9CA5E",
                    "#FC619C",
                    "#C177FF",
                    "#015aae",
                    "#f65c32",
                    "#d60077",
                    "#d1c0a5",
                    "#015aae",
                    "#8715c3",
                    "#dd2137",
                    "#fcb8d6",
                    "#8fe0e6"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
            data: this.seriesData
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // 收支对比趋势图
    intOutCompareLine(e) {
      let myChart = this.$echarts.init(this.$refs.intOutCompareLine);
      myChart.showLoading({
        text: "数据获取中",
        textColor: "#fff",
        effect: "whirling",
        maskColor: "rgba(255, 255, 255, 0)"
      });
      setTimeout(function() {
        myChart.hideLoading();
      }, 500);
      myChart.clear();
      //x轴
      this.xData = (function() {
        let res = [];
        let len = e.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push(e[i].year + "-" + e[i].month);
        }
        return res;
      })();
      //收入数据
      this.seriesData0 = (function() {
        let res = [];
        let len = e.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push(e[i].income.toFixed(2));
        }
        return res;
      })();
      //支出数据
      this.seriesData1 = (function() {
        let res = [];
        let len = e.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push(e[i].expenditure.toFixed(2));
        }
        return res;
      })();
      //结余数据
      this.seriesData2 = (function() {
        let res = [];
        let len = e.length;
        for (let i = 0, size = len; i < size; i++) {
          res.push(e[i].balance.toFixed(2));
        }
        return res;
      })();
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "rgba(255,255,255,0.0001)"
            }
          }
        },
        title: {
          text: "收支对比趋势图",
          subtext: this.memoryValue === 'date' ? (this.compareStart + "-" + this.compareEnd) : '',
          x: "center",
          itemGap: 15,
          top: 20,
          textStyle: {
            color: "#333333",
            fontSize: 20,
            fontWeight: "bold"
          },
          subtextStyle: {
            color: "#999",
            fontSize: 16
          }
        },
        legend: {
          itemGap: 20,
          left: "center",
          bottom: 10,
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 14,
            fontFamily: "Microsoft YaHei"
          },
          x: "right",
          data: ["收入", "支出", "结余"]
        },
        grid: {
          left: "1%",
          right: "4%",
          bottom: "10%",
          top: "20%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: false
            },

            axisLabel: {
              color: "#333",
              fontSize: 15
            },
            axisTick: {
              //y轴刻度线
              show: false
            },
            data: this.xData
          }
        ],
        yAxis: [
          {
            axisLabel: {
              color: "#999",
              fontSize: 14
            },
            axisLine: {
              show: false
            },
            axisTick: {
              //y轴刻度线
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "rgba(234,234,234,1)"
              }
            },
            type: "value"
          }
        ],
        color: ["#FC619C", "#29C8A2", "#4A89F1"],
        series: [
          {
            name: "收入",
            type: "line",
            smooth: true,
            // stack: "广告",
            data: this.seriesData0
          },
          {
            name: "支出",
            type: "line",
            smooth: true,
            // stack: "广告",
            data: this.seriesData1
          },
          {
            name: "结余",
            type: "line",
            smooth: true,
            // stack: "广告",
            data: this.seriesData2
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    //支出堆积图
    outBar(e) {
      this.$nextTick(() => {
        let myChart = this.$echarts.init(this.$refs.outBar);
        myChart.showLoading({
          text: "数据获取中",
          textColor: "#fff",
          effect: "whirling",
          maskColor: "rgba(255, 255, 255, 0)"
        });
        setTimeout(function() {
          myChart.hideLoading();
        }, 500);
        myChart.clear();

        myChart.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              lineStyle: {
                color: "rgba(255,255,255,0.0001)"
              }
            },
            extraCssText: 'white-space: pre-wrap;', // 覆盖默认样式
            formatter: function(params) {
              const dataStrings = params.filter(item => item.value != 0)
                                  .map(item => `${item.seriesName}: ${item.value}万元`);
              return dataStrings.join('\n');
            }
          },
          title: {
            text: "支出堆积图",
            subtext: this.memoryValue === 'date' ? (this.outStart + "-" + this.outEnd) : '',
            x: "center",
            itemGap: 15,
            top: 20,
            textStyle: {
              color: "#333333",
              fontSize: 20,
              fontWeight: "bold"
            },
            subtextStyle: {
              color: "#999",
              fontSize: 16
            }
          },
          grid: {
            left: "1%",
            right: "4%",
            bottom: "5%",
            top: "20%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              axisLine: {
                show: false
              },
              axisLabel: {
                color: "#333",
                fontSize: 15
              },
              axisTick: {
                //y轴刻度线
                show: false
              },
              data: this.xDataName
            }
          ],
          yAxis: [
            {
              axisLabel: {
                color: "#999",
                fontSize: 14,
                formatter: function(value, index) {
                    return (value).toFixed(2) + ' 万元';
                }
              },
              axisLine: {
                show: false
              },
              name: this.unitY,
              axisTick: {
                //y轴刻度线
                show: false
              },
              splitLine: {
                lineStyle: {
                  color: "rgba(234,234,234,1)"
                }
              },
              type: "value"
            }
          ],
          color: ["#4A89F1", "#29C8A2", "#F9CA5E", "#FC619C", "#C177FF"],
          series: this.getDataSeries()
          //  [
          //   {
          //     name: "邮件营销",
          //     barWidth: 40, //柱图宽度
          //     type: "bar",
          //     stack: "广告",
          //     data: [0, 132, 101, 134, 90, 230, 210]
          //   },
          //   {
          //     name: "联盟广告",
          //     type: "bar",
          //     barWidth: 40, //柱图宽度
          //     stack: "广告",
          //     data: [220, 182, 191, 234, 290, 330, 310]
          //   },
          //   {
          //     name: "视频广告",
          //     barWidth: 40, //柱图宽度
          //     type: "bar",
          //     stack: "广告",
          //     data: [150, 232, 201, 154, 190, 330, 410]
          //   }
          // ]
        });
        window.addEventListener("resize", function() {
          myChart.resize();
        });
      });
    },
    // 获取柱状图数组数据
    getValueObj(array) {
      let obj = [];
      for (let i = 0; i < this.expenseLegendData.length; i++) {
        obj[i] = [];
      }
      for (let i = 0; i < this.expenseLegendData.length; i++) {
        array.forEach(element => {
          let findObj = element.item.find(m => {
            if (this.expenseLegendData[i] == m.costName) {
              return true;
            }
          });
          if (findObj) {
            obj[i].push((findObj.amount / 10000).toFixed(2));
          } else {
            obj[i].push(0);
          }
        });
      }
      return obj;
    },
    // 循环 获取series 柱状图
    getDataSeries() {
      let seriesList = [];
      for (let i = 0; i < this.expenseLegendData.length; i++) {
        seriesList.push({
          name: this.expenseLegendData[i],
          barWidth: 40, //柱图宽度
          type: "bar",
          stack: "广告",
          barGap: 0,
          data: this.getValueObj(this.restructuringData)[i], //  获取折线数据
          itemStyle: {
            normal: {
              barBorderRadius: [2, 2, 0, 0] //圆角
            }
          }
        });
      }
      return seriesList;
    },
    // 获取x轴
    async getThebase(array) {
      let arr = [];
      array.forEach(item => {
        arr.push(item.item[0].costPname);
      });
      return arr;
    },
    // 获取legend的个数
    getLegend(array) {
      let arr = [];
      let obj = {};
      let index = 0;
      array.forEach(element => {
        if (!obj.hasOwnProperty(element.costName)) {
          obj[element.costName] = element.costName;
          arr.push(element.costName);
        }
      });
      return arr;
    },
    // 数组重组
    arrayReorganization(array) {
      let arr = [];
      let obj = {};
      let index = 0;
      array.forEach(element => {
        if (obj.hasOwnProperty(element.costPid)) {
          arr[obj[element.costPid]].item.push(element);
        } else {
          obj[element.costPid] = index++;
          arr.push({
            name: element.costPid,
            item: [element]
          });
        }
      });
      return arr;
    },
    groupByName(array) {
      let arr = [];
      let obj = {};
      let index = 0;
      let count = 0;
      array.forEach(element => {
        if (obj.hasOwnProperty(element.costPname)) {
          arr[obj[element.costPname]].item.push(element);
        } else {
          obj[element.costPname] = index++;
          arr.push({
            name: element.costPname,
            costPname: element.costPname,
            count: 0,
            item: [element]
          });
        }
      });
      this.getAllcount(arr);
      // 将营业成本放最后面
      const item = arr.splice(arr.findIndex( item => item.costPname === '营业成本'), 1)[0];
      arr.push(item);
      // 在营业成本前增加小计行
      arr.splice(arr.length - 1, 0, { costName: "",
        count: arr.slice(0, -1).reduce((acc, item) => acc + item.count, 0),
        name: "小计"
      })
      // 假id，属性表格用
      let num1 = 0
      let num2 = 1000
      arr.forEach( item => {
        item.id = ++num1
        if(item.item){
          item.item.hasChildren = true
          item.item.forEach( item => {
            item.id = ++num2
          })
        }
      })
      // 造总计行
      arr.push({
        costName: "",
        count: arr[arr.length - 2].count + arr[arr.length - 1].count,
        name: "支出总计（元）"
      })
      console.log(arr);
      return arr;
    },
    groupByYear(array) {
      let arr = [];
      let obj = {};
      let index = 0;
      let income = 0;
      let expenditure = 0;
      let balance = 0;
      array.forEach(element => {
        if (obj.hasOwnProperty(element.year)) {
          arr[obj[element.year]].item.push(element);
        } else {
          obj[element.year] = index++;
          arr.push({
            name: element.year,
            income: 0,
            expenditure: 0,
            balance: 0,
            item: [element]
          });
        }
      });
      this.getyearCount(arr);
      return arr;
    },
    getyearCount(arr) {
      arr.forEach(element => {
        element.item.forEach(m => {
          element.income = element.income + parseFloat(m.income.toFixed(2));
          element.expenditure =
            element.expenditure + parseFloat(m.expenditure.toFixed(2));
          element.balance =
            parseFloat(element.balance.toFixed(2)) +
            parseFloat(m.balance.toFixed(2));
        });
      });
    },
    getAllcount(arr) {
      arr.forEach(element => {
        element.item.forEach(m => {
          element.count = element.count + parseFloat(m.amount.toFixed(2));
        });
      });
    },
    cellClassName({row, column, rowIndex, columnIndex}){
      if(['小计', '支出总计（元）'].includes(row.name)){
        return 'cell-class-name'
      }
    }
  }
};
</script>
<style lang="stylus" >
.tab{
  .el-select{
    width:100px !important;
    min-width:100px !important;
  }
  .el-input--small{
    width:100px !important;
    min-width:100px !important;
  }
}
  
// .expanded:nth-of-type(even)
//   background #FFFBF4!important;

  
.inOutReport
  .cell-class-name:last-child .cell
    color: #008b24 !important;
    font-size: 14px;
    font-weight: 700;
  .table-container .el-table .el-table__row
    background:white !important;
  .table-container .el-table .el-table__row--level-0
    background:#f2f9ff !important;
  // .el-table__row:nth-child(odd)  td 
  //   background:yellow !important;
  // .el-table__row:nth-child(even) td 
  //   background:red !important;
  // .expanded:nth-child(even) td 
  //   background:red !important;
  // tr.el-table__row.expanded:nth-child(odd) + tr:not(.el-table__row ) td 
  //   background:#fff !important;
  // tr.el-table__row.expanded:nth-child(even) + tr:not(.el-table__row) td 
  //   background rgba(242, 249, 255, 1) !important;
  .el-table tr:hover>td {
    background:none !important;
  }
  .el-table tr >td{
    background:none !important;
  }
  .el-table .warning-row {
    background rgba(242, 249, 255, 1) !important;
  }
  .el-table .success-row  {
    background: #fff;
  }
  .expense:last-child,.compare:last-child
    border-bottom:1px solid #eee!important;
  .expense
    display:flex;
    box-sizing: border-box;
    padding-left:48px;
    >span
      box-sizing: border-box;
      padding-left:30px;
      text-align:center;
      flex:0 0 33.33%;
      padding:0 10px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #333;
      line-height: 45px;
      // border-bottom:1px solid #eee;
  .compare
    display:flex;
    box-sizing: border-box;
    padding-left:48px;
    >span
      box-sizing: border-box;
      flex:0 0 20% !important;
      padding:0 10px;
      font-size: 14px;
      text-align:center;
      font-family: MicrosoftYaHei;
      color: #333;
      line-height: 45px;
      // border-bottom:1px solid #eee;

  // .select-container-box:nth-child(3)
  //   .el-input--small
  //     width 135px!important
  //     height 38px!important
  //     min-width 135px!important
  // .select-container-box:nth-child(6),.select-container-box:nth-child(7)
  //   .el-input--small
  //     width 96px!important
  //     height 38px!important
  //     min-width 96px!important
  .title-container
    position:relative;
    img
      position absolute
      top:5px;
      left:100px;
  .content-container
    .onePart,.twoPart
      // margin-top:12px;
      display:flex;
      .left
        width:60%;
      .right
        width:40%;
        margin-left:20px;
        margin-top:15px;
        // align-self:center;
    .therePart
      margin-top:12px;
      .therePart-table 
        padding:30px 30px;
      .demo-table-expand {
        font-size: 0;
      }
      .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
      }
      .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
      }
    //表格样式
    .therePart
      .el-table::before
        width:100%!important
        height:0px;
      .el-table
        border:1px solid rgba(234, 234, 234, 1);
        border-bottom:1px solid rgba(234, 234, 234, 1);;
      .el-table .el-table__header th
          border-bottom:1px solid #EAEAEA;
          padding 0
          background-color #f7f7f7
          color rgb(51, 51, 51)
          font-weight bold
      .el-table .el-table__row td
          border-bottom:1px solid #EAEAEA!important;
      
            
      .el-table .el-table__footer-wrapper 
        .has-gutter
          >tr td:nth-child(4)
            .cell
              color:#008B24;
              z-index:9999;
              text-align:center;
              font-size:14px;
              font-family:MicrosoftYaHei-Bold;
              font-weight:bold;
            .cell:before 
                position: absolute;
                z-index: 3;
                content: "￥";
                margin-left:-15px;
          >tr td:nth-child(5)
            .cell
              color:#E10004;
              z-index:9999;
              text-align:center;
              font-size:14px;
              font-family:MicrosoftYaHei-Bold;
              font-weight:bold;
            .cell:before 
              position: absolute;
              z-index: 3;
              content: "￥";
              margin-left:-15px;
          >tr td:nth-child(6)
            .cell
              color:#333333;
              z-index:9999;
              text-align:center;
              font-size:14px;
              font-family:MicrosoftYaHei-Bold;
              font-weight:bold;
            .cell:before 
              position: absolute;
              z-index: 3;
              content: "￥";
              margin-left:-15px;


        table
          border-bottom none
          border-top 1px solid  #EAEAEA
        // td
        //   padding 0
        //   height 45px
        //   border none
      .el-table
        .el-table__body tbody
          td
            padding 0
            border-bottom 0
            height 37px

          &:last-child
            border-right 1px solid #fff
            border-bottom none
            background rgb(242,243,246)
            .cell
              font-size 14px
              font-family MicrosoftYaHei
              color #333
              line-height 47px
    .twoPart
      .el-table .el-table__footer-wrapper 
        .has-gutter
          >tr td:nth-child(2)
            .cell
              color:#E10004;
              z-index:9999;
              text-align:center;
              font-size:14px;
              font-family:MicrosoftYaHei-Bold;
              font-weight:bold;
            .cell:before 
                position: absolute;
                z-index: 3;
                content: "￥";
                margin-left:-15px;
    .onePart,.twoPart
      .right 
        .el-table::before
          width:100%!important
          height:0px;
        .el-table
          border:1px solid rgba(234, 234, 234, 1);
          border-bottom:1px solid rgba(234, 234, 234, 1);;
        .el-table .el-table__header th
            border-bottom:1px solid #EAEAEA;
            padding 0
            background-color #f7f7f7
            color rgb(51, 51, 51)
            font-weight bold
        .el-table .el-table__row td
            border-bottom:1px solid #EAEAEA!important;
        // .el-table
        //   .expanded
        //       .el-table__expand-column:nth-of-type(even)
        //         .expense
        //           background rgba(242, 249, 255,1)!important;
              
        .el-table .el-table__footer-wrapper 
          .has-gutter
            >tr td:nth-child(4)
              position:relative
              .cell
                color:#008B24;
                z-index:9999;
                text-align:center;
                font-size:14px;
                font-family:MicrosoftYaHei-Bold;
                font-weight:bold;
              .cell:before 
                position: absolute;
                z-index: 3;
                content: "￥";
                margin-left:-15px;
          table
            border-bottom none
            border-top 1px solid  #EAEAEA
          // td
          //   padding 0
          //   height 45px
          //   border none
        .el-table
          .el-table__body tbody
            td
              padding 0
              border-bottom 0
              height 37px

            &:last-child
              border-right 1px solid #fff
              border-bottom none
              background rgb(242,243,246)
              .cell
                font-size 14px
                font-family MicrosoftYaHei
                color #333
                line-height 47px
    .onePart,.twoPart
      .left
        position:relative;
        .nodata
          img
            position:absolute;
            left:43%;
            top:35%;
          span
            position:absolute;
            left:46%;
            top:62%;
            color:#666;
            font-size:20px;

    
  
</style>
